import axios from 'axios'
import CryptoJS from 'crypto-js'

export function encryptAES(data: string): string {
  const key = CryptoJS.SHA256(String(process.env.NEXT_PUBLIC_SECRET_PARAM)) // menghasilkan 32-byte key
  const iv = CryptoJS.lib.WordArray.random(16)

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  const combined = iv.concat(encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(combined)
}
async function getUrlApi(): Promise<string | false> {
  const mainUrl = process.env.NEXT_PUBLIC_API_URL as string
  const alternativeUrl = process.env.NEXT_PUBLIC_API_URL_LOCAL as string

  async function fetchData(url: string): Promise<string | null> {
    const formData = {
      user: '123',
      pass: '123'
    }
    const encryptedData = encryptAES(JSON.stringify(formData))
    try {
      const response = await axios.post(
        `${url}login/loginadmin`,
        {
          data: encryptedData
        },
        {
          timeout: 10000
        }
      )

      if (response.status >= 400) {
        console.error(`Error: HTTP status ${response.status}`)

        return null
      }

      return url
    } catch (error) {
      if (axios.isAxiosError(error) && error.code === 'ECONNREFUSED') {
        console.error(`Connection refused: ${url}`)
      } else {
        console.error(`Error: ${error instanceof Error ? error.message : 'Unknown error'}`)
      }

      return null
    }
  }

  try {
    let data = await fetchData(mainUrl)

    if (!data) {
      data = await fetchData(alternativeUrl)
    }

    if (data) {
      return data
    } else {
      console.error('Failed to fetch data from both URLs.')

      return false
    }
  } catch (error) {
    console.error('An unexpected error occurred:', error instanceof Error ? error.message : 'Unknown error')

    return false
  }
}

export default getUrlApi
